import React from "react";
import SmartLink from "components/SmartLink";
import MetaManager from "components/MetaManager";

const NotFound = () => {
	// Constants for recurring values
	const notFoundImage = "/page/img/meta-image.jpg";
	const notFoundTitle = "404 | Oops! This page has been blown away";
	const notFoundDescription = "Oops, the page you were looking for could not be found! Check the URL or return to the homepage to continue browsing.";

	return (
		<>
			<MetaManager 
				title={notFoundTitle}
				description={notFoundDescription}
				
				// Schema.org for Google
				schemaImage={notFoundImage}
				
				// Open Graph properties
				ogTitle={notFoundTitle}
				ogDescription={notFoundDescription}
				ogImage={notFoundImage}
				ogUrl="/404"
				ogSiteName={notFoundTitle}
				ogLocale="de_DE"
				
				// Twitter Card properties
				twitterCard="summary_large_image"
				twitterTitle={notFoundTitle}
				twitterDescription={notFoundDescription}
			/>
			<div className="container text-center my-n5">
				<div className="row justify-content-center align-items-center vh-100">
					<div className="col-md-8">
						<h1 className="display-4 fw-bold text-danger">404 - Page not found</h1>
						<p className="lead text-muted mt-3">The page you are looking for does not exist or has been moved.</p>
						{/* <img
							src="https://via.placeholder.com/500x300?text=404+Not+Found"
							alt="404 Not Found"
							className="img-fluid my-4"
						/> */}
						<SmartLink
							to="/"
							className="btn btn-primary btn-lg">
							Back to Homepage
						</SmartLink>
					</div>
				</div>
			</div>
		</>
	);
};

export default NotFound;
